export const INDIA_STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
  "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
  "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
  "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
  // UTs
  "Andaman and Nicobar Islands", "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Jammu and Kashmir",
  "Ladakh", "Lakshadweep", "Puducherry",
] as const;

export type IndiaState = (typeof INDIA_STATES)[number];

export interface PincodeLookup {
  state: string;
  district: string;
  cities: string[]; // post office / area names
}

export async function lookupPincode(pincode: string): Promise<PincodeLookup | null> {
  if (!/^\d{6}$/.test(pincode)) return null;
  try {
    const res = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
    const json = await res.json();
    const first = Array.isArray(json) ? json[0] : null;
    if (!first || first.Status !== "Success" || !first.PostOffice?.length) return null;
    const po = first.PostOffice;
    return {
      state: po[0].State,
      district: po[0].District,
      cities: Array.from(new Set(po.map((p: { Name: string }) => p.Name))),
    };
  } catch {
    return null;
  }
}
